import { connect } from 'react-redux';
import { getFlags } from '../../redux/flags/selectors';
import { getThemeSkin, getPageThumb, getSeoCanonical, getIsMobile, getSeoTitle, getSeoDescription, getSeoPrevUrl, getSeoNextUrl, getIsIOS, } from '../../publicSession/selectors';
import { getChatNewMessageArrived } from '../../Chat/redux/selectors';
var mapStateToProps = function (state) { return ({
    flags: getFlags(state),
    isMobile: getIsMobile(state),
    isIOS: getIsIOS(state),
    themeSkin: getThemeSkin(state),
    pageThumb: getPageThumb(state),
    pageUrl: getSeoCanonical(state),
    pageTitle: getSeoTitle(state),
    pageDescription: getSeoDescription(state),
    hasNewChatMessage: getChatNewMessageArrived(state),
    prevUrl: getSeoPrevUrl(state),
    nextUrl: getSeoNextUrl(state),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=Head.container.js.map